/**
 * RestoID — Register is HIDDEN.
 * ---------------------------------------------------------------------------
 * Accounts are created automatically on the first sign-in (phone verification
 * code), so the registration page is not shown. Any hit to /register redirects
 * to /sign-in, preserving search params (app_id, one-time-token) so those flows
 * still route correctly via the sign-in guards.
 * Swapped in for `./pages/Register` via `src/App.tsx`.
 */
import { Navigate, useSearchParams } from 'react-router-dom';

const Register = () => {
  const [params] = useSearchParams();
  const search = params.toString();

  return <Navigate replace to={{ pathname: '/sign-in', search: search ? `?${search}` : '' }} />;
};

export default Register;
